<template>
  <v-btn icon :color="color" @click="doHandlerClick()">
    <v-icon medium>{{iconCls}}</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "RyouDelBtn",
  props: {
    color: {
      type: String,
      required: false,
      default: "#D84315"
    },
    iconCls: {
      type: String,
      required: false,
      default: "mdi-delete"
    },
    handlerClick: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  methods: {
    doHandlerClick() {
      this.handlerClick();
    }
  },
  computed: {}
};
</script>

<style scoped>
</style>
